import {AppInsightsAdapter} from '@hconnect/common/logging'
import {hpTheme} from '@hconnect/uikit/src/lib2'
import {
  FundamentalContextProvider,
  ThemeProvider as FundamentalThemeProvider
} from '@hm/fundamental'
import {CssBaseline, ThemeProvider} from '@mui/material'
import {Suspense} from 'react'
import {createRoot} from 'react-dom/client'
import {createBrowserRouter, RouterProvider} from 'react-router'

import {mockStore} from './__mock__/mockStoreSingleton'
import {AppWrapper} from './App'
import {FundamentalThemeInitializer} from './shared/components'
import {createApi} from './shared/provider/createApi'
import {ErrorBoundary} from './shared/provider/ErrorBoundary'
import './index.css'

const api = mockStore.isEnabled()
  ? createApi({throwOnNoMatch: true, mockEverything: true})
  : createApi({throwOnNoMatch: false, mockEverything: false})

// activate the userTracking of Azure
AppInsightsAdapter.init()
AppInsightsAdapter.allowTracking()

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <ErrorBoundary>
        <AppWrapper api={api} />
      </ErrorBoundary>
    )
  }
])

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)

root.render(
  <Suspense fallback={<div />}>
    <FundamentalContextProvider>
      <FundamentalThemeProvider>
        <FundamentalThemeInitializer />
        <ThemeProvider theme={hpTheme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </FundamentalThemeProvider>
    </FundamentalContextProvider>
  </Suspense>
)
